export const PAYMENT_TYPES = Object.freeze({
  REPAYMENT: 'repayment',
  ROLLOVER: 'rollover',
});

export const PAYMENT_VARIANTS = Object.freeze({
  PAY: 'pay',
  ADD_CARD_AND_PAY: 'add_card_and_pay',
});

export const CARD_TYPES = Object.freeze({
  VISA: 'v',
  MASTERCARD: 'm',
});

export const INCOMING_PAYMENT_PROVIDERS = Object.freeze({
  EPOINT: 'epoint_website',
  HESAB: 'hesab_website',
});

export const ACCOUNT_TYPES = Object.freeze({
  CARD: 'credit_card',
  BANK: 'bank_transfer',
  E_WALLET: 'wallet',
});

export const DEFAULT_WALLET_TYPE = 'm10';

export const MOBILE_OPERATOR_CODES_DEFAULT = ['10', '50', '51', '55', '70', '77', '99'];
